import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from '../components/loading/LoadingIndicator';

// Create the context
const LoadingContext = createContext();

// Custom hook to use the loading context
export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

// Provider component
export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');

  // Start loading
  const startLoading = (message = '') => {
    setLoadingMessage(message);
    setLoading(true);
  };

  // Stop loading
  const stopLoading = () => {
    setLoading(false);
    setLoadingMessage('');
  };

  // Value object to be provided to consumers
  const value = {
    loading,
    loadingMessage,
    startLoading,
    stopLoading
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
      {loading && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl max-w-md w-full">
            <LoadingIndicator size="lg" />
            {loadingMessage && (
              <p className="text-center mt-4 text-gray-700 dark:text-gray-300 font-medium">
                {loadingMessage}
              </p>
            )}
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  );
};

LoadingProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default LoadingProvider; 